import { ReactElement, ReactNode } from 'react';
import { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { Outlet, matchPath, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Tabs } from 'common/components/antd/Tabs/Tabs';
import { ROUTES_MAPPING } from 'navigation/constants/route.constants';
import { ERoutePathParams } from 'navigation/enums/rout-path-params.enum';
import HeaderComponent from './components/Header/Header.component';
import {
  STitle,
  SHeader,
  SContent,
  SContainer,
  STabs,
} from './limits.layout.style';

type TTab = {
  path: string;
  key: string;
  label: ReactNode;
  extraContent: ReactNode;
};

enum ESectionKey {
  StandardLimits = 'standard-limits',
  IndividualLimits = 'individual-limits',
}

const LimitsLayout = (): ReactElement => {
  const navigate = useNavigate();

  const location = useLocation();
  const { t } = useTranslation();
  const { counterparty } = useParams();

  const tabs: TTab[] = [
    {
      key: ESectionKey.StandardLimits,
      label: t('limits.tabs.standardLimits.title'),
      path: ROUTES_MAPPING.PROTECTED.LIMITS_STANDARD_LIMITS,
      extraContent: null,
    },
    {
      key: ESectionKey.IndividualLimits,
      label: t('limits.tabs.individualLimits.title'),
      path: ROUTES_MAPPING.PROTECTED.LIMITS_INDIVIDUAL_LIMITS,
      extraContent: null,
    },
  ];

  const activeTab = tabs.find((tab) => {
    const match = matchPath(
      {
        path: tab.path,
        end: false,
        caseSensitive: false,
      },
      location.pathname,
    );

    return !!match;
  });

  const extraContent = {
    right: activeTab?.extraContent,
    left: <div style={{ width: 24 }} />,
  };

  const onChangeTab: TabsProps['onChange'] = (key) => {
    const tabChangeTo = tabs.find((tab) => tab.key === key);
    if (tabChangeTo) {
      navigate(tabChangeTo.path.replace(ERoutePathParams.Counterparty, counterparty || ''));
    }
  };

  return (
    <SContainer>
      <STitle>{t('limits.title')}</STitle>
      <SHeader>
        <HeaderComponent />
      </SHeader>
      <SContent>
        <STabs>
          <Tabs
            onChange={onChangeTab}
            activeKey={activeTab?.key}
            tabBarExtraContent={extraContent}
            defaultActiveKey="1"
            items={tabs}
          />
          <Outlet />
        </STabs>
      </SContent>
    </SContainer>
  );
};
export default LimitsLayout;
